import NotFound from '../components/dashboard/NotFound';
import Dashboard from '../components/dashboard/Dashboard';
import FirstWebsite from '../components/dashboard/DashboardCreateSite';
import CreateWebsiteWithoutTemplate from '../components/dashboard/CreateWebsiteWithoutTemplate.vue';
import Redirector from '../components/external/Redirector';
// import UserSettings from '../components/dashboard/pages/UserSettings';
const UserSettings = ()=> import(/* webpackChunkName: "user-settings" */'../components/dashboard/pages/UserSettings');
import Tags from '../components/dashboard/Tags';
const AiResources = () => import(/* webpackChunkName: "ai-resources" */'../components/dashboard/pages/AiResources');
import Login from '../components/dashboard/Login';
import Editor from '../components/editor/base/Editor';
import Items from '../components/dashboard/pages/Items';
import Analytics from '../components/dashboard/pages/Analytics';
import Site from '../components/dashboard/Site';
import CheetahTurboPage from '../components/dashboard/pages/CheetahTurboPage';
import WebsiteHome from '../components/dashboard/views/WebsiteHome';
import PageCreate from '../components/dashboard/pages/Page';
import PageEdit from '../components/dashboard/pages/Page';
import PageVersions from '../components/dashboard/pages/Versions';
import GDPRSettings from '../components/dashboard/pages/GDPRSettings';
import SiteMembers from '../components/dashboard/pages/Members/Members';
import FormMembers from '../components/dashboard/pages/FormMembers';
import PublicLinkSave from '../components/dashboard/PublicLinkSave';
import TemplatePreview from '../components/external/TemplatePreview.vue';
import Domain from '../components/dashboard/pages/Domain';
import GeneralSettings from '../components/dashboard/views/GeneralSettings.vue';
import Integrations from '../components/dashboard/views/Integrations.vue';
import Others from '../components/dashboard/views/Others.vue';
const SupercheckoutBridge = () =>
  import(/* webpackChunkName: "supercheckout-bridge" */ '../components/dashboard/pages/SupercheckoutBridge.vue');
const AiEditorShell = () =>
  import(/* webpackChunkName: "ai-editor" */ '../components/ai-editor/AiEditorShell.vue');

export default [
  /*
   * Not required auth - Begin
   * */
  {
    path: '*',
    component: NotFound
  },

  {
    path: '/not-found',
    name: 'NotFound',
    component: NotFound
  },

  {
    path: '/login/:email?/:password?/:office_token?/:plan?',
    name: 'Login',
    component: Login
  },

  {
    path: '/website/public-link/:website_id',
    name: 'PublicLinkSave',
    component: PublicLinkSave
  },

  {
    path: '/template-preview/:template_slug',
    name: 'TemplatePreview',
    component: TemplatePreview
  },

  {
    path: '/mboss-redirect/:id_page',
    name: 'Redirector',
    component: Redirector
  },
  {
    path: '/super-checkout-redirect/:id_page',
    name: 'Redirector',
    component: Redirector
  },
  {
    path: '/elearning-redirect/:id_page',
    name: 'RedirectElearning',
    component: Redirector
  },

  {
    path: '/cheetah-redirect/:id_page',
    name: 'CheetahRedirectorPage',
    component: Redirector
  },

  /*
   * Not required auth - End
   * */

  {
    path: '/home',
    name: 'Dashboard',
    props: (route) => ({query: route.query.q}),
    component: Dashboard,
    meta: {title: 'dashboard', requiresAuth: true}
  },
  {
    path: '/home',
    name: 'Home',
    props: (route) => ({query: route.query.q}),
    component: Dashboard,
    meta: {title: 'dashboard',
      requiresAuth: true,
      breadcrumb: [
        {
          title: 'my-websites',
          active: true
        }
      ]
    }
  },
  {
    path: '/create-website',
    name: 'CreateWebsite',
    props: (route) => ({query: route.query.q}),
    component: FirstWebsite,
    meta: {requiresAuth: true,
      breadcrumb: [
        {
          title: 'new-website',
          active: true
        }
      ]
    }
  },
  {
    path: '/create-website-without-template/:flag',
    name: 'CreateWebsiteWithout',
    props: (route) => ({query: route.query.q}),
    component: CreateWebsiteWithoutTemplate,
    meta: {requiresAuth: true}
  },
  {
    path: '/user/settings',
    name: 'UserSettings',
    component: UserSettings,
    meta: {
      requiresAuth: true,
      breadcrumb: [
        {
          title: 'user-settings',
          active: true
        }
      ]
    }
  },

  {
    path: '/tags',
    name: 'Tags',
    component: Tags,
    meta: {
      requiresAuth: true,
      breadcrumb: [
        {
          title: 'tags',
          active: true
        }
      ]
    }
  },

  {
    path: '/ai-resources',
    name: 'AiResources',
    component: AiResources,
    meta: {requiresAuth: true}
  },

  {
    path: '/editor/:page_id',
    name: 'editor',
    component: Editor,
    meta: {requiresAuth: true}
  },
  {
    path: '/supercheckout-bridge',
    name: 'supercheckout-bridge',
    component: SupercheckoutBridge,
    meta: { requiresAuth: true }
  },
  {
    path: '/ai-editor/:id',
    name: 'AiEditor',
    component: AiEditorShell,
    meta: { requiresAuth: true }
  },
  {
    path: '/editor-layout-item/:type/:id_item/:website_id',
    name: 'editor-layout-item',
    component: Editor,
    meta: {requiresAuth: true}
  },
  {
    path: '/editor-default-item/:id_default_item',
    name: 'editor-default-item',
    component: Editor,
    meta: {requiresAuth: true}
  },

  {
    path: '/site/:id',
    // name: 'Site',
    component: Site,
    meta: {
      requiresAuth: true,
      breadcrumb: [
        {
          title: 'my-site',
          active: true
        }
      ]
    },
    children: [
      {
        path: '',
        name: 'SitePages',
        component: WebsiteHome,
        meta: {
          requiresAuth: true,
          breadcrumb: [
            {
              title: 'website',
              link: 'Site',
              active: false,
              params: 'id'
            },
            {
              title: 'my-pages',
              active: true
            }
          ]
        }
      },
      // {
      //   path: 'restore-pages',
      //   name: 'SiteRestorePages',
      //   component: WebsiteRestorePages,
      //   meta: {
      //     requiresAuth: true,
      //     breadcrumb: [
      //       {
      //         title: 'restore-pages',
      //         active: true
      //       }
      //     ]
      //   }
      // },
      {
        path: 'page/edit/:page_id',
        name: 'SitePageEdit',
        component: PageCreate,
        meta: {
          requiresAuth: true,
          breadcrumb: [
            {
              title: 'website',
              link: 'SitePages',
              active: false,
              params: 'id'
            },
            {
              title: 'page-edit',
              active: true
            }

          ]
        }
      },
      {
        path: 'page/versions/:page_id',
        name: 'SitePageVersions',
        component: PageVersions,
        meta: {
          requiresAuth: true,
          breadcrumb: [
            {
              title: 'website',
              link: 'SitePages',
              active: false,
              params: 'id'
            },
            {
              title: 'version-control',
              active: true
            }

          ]
        }
      },
      {
        path: 'page/create/:layout_id',
        name: 'SitePageCreate',
        component: PageEdit,
        meta: {
          requiresAuth: true,
          breadcrumb: [
            {
              title: 'website',
              link: 'Site',
              active: false,
              params: 'id'
            },
            {
              title: 'my-pages',
              link: 'SitePages',
              active: false,
              params: 'id'
            },
            {
              title: 'page-create',
              active: true
            }
          ]
        }
      },
      {
        path: '/site/settings/:id/:type?',
        // name: 'SiteSettings',
        // component: SiteSettings,
        name: 'GeneralSettings',
        component: GeneralSettings,
        meta: {
          requiresAuth: true,
          breadcrumb: [
            {
              title: 'website',
              link: 'Site',
              active: false,
              params: 'id'
            },
            {
              title: 'general-settings',
              active: true
            }
          ]
        }
      },
      {
        path: '/site/integrations/:id',
        // name: 'SiteSettings',
        // component: SiteSettings,
        name: 'Integrations',
        component: Integrations,
        meta: {
          requiresAuth: true,
          breadcrumb: [
            {
              title: 'website',
              link: 'Site',
              active: false,
              params: 'id'
            },
            {
              title: 'integrations',
              active: true
            }
          ]
        }
      },
      {
        path: '/site/gdpr-settings/:id',
        name: 'GDPRSettings',
        component: GDPRSettings,
        meta: {
          requiresAuth: true,
          breadcrumb: [
            {
              title: 'website',
              link: 'SitePages',
              active: false,
              params: 'id'
            },
            {
              title: 'gdpr',
              active: true
            }
          ]
        }
      },
      // {
      //   path: '/site/multiaction/edit/:action_id/:id',
      //   name: 'MultiActionEdit',
      //   component: MultiAction,
      //   meta: {
      //     breadcrumb: [
      //       {
      //         title: 'website',
      //         link: 'SitePages',
      //         active: false,
      //         params: 'id'
      //       },
      //       {
      //         title: 'multi-action',
      //         active: true
      //       }
      //     ]
      //   }
      // },
      // {
      //   path: '/site/split-test/:id',
      //   name: 'SplitTest',
      //   component: SplitTest,
      //   meta: {
      //     breadcrumb: [
      //       {
      //         title: 'website',
      //         link: 'Site',
      //         active: false,
      //         params: 'id'
      //       },
      //       {
      //         title: 'split-test',
      //         active: true
      //       }
      //     ]
      //   }
      // },
      {
        path: '/site/members/:website_id',
        name: 'SiteMembers',
        component: SiteMembers,
        meta: {
          requiresAuth: true,
          breadcrumb: [
            {
              title: 'website',
              link: 'Site',
              active: false,
              params: 'website_id'
            },
            {
              title: 'members-area',
              active: true
            }
          ]
        }
      },
      // {
      //   path: '/site/emails-config/:website_id',
      //   name: 'Emails',
      //   component: Emails,
      //   meta: {
      //     requiresAuth: true,
      //     breadcrumb: [
      //       {
      //         title: 'website',
      //         link: 'SitePages',
      //         active: false,
      //         params: 'id'
      //       },
      //       {
      //         title: 'automatic-emails',
      //         active: true
      //       }
      //     ]
      //   }
      // },
      // {
      //   path: '/site/emails-integrations-config/:website_id',
      //   name: 'EmailsIntegrations',
      //   component: EmailsIntegrations,
      //   meta: {
      //     requiresAuth: true,
      //     breadcrumb: [
      //       {
      //         title: 'website',
      //         link: 'SitePages',
      //         active: false,
      //         params: 'id'
      //       },
      //       {
      //         title: 'automatic-emails-integrations',
      //         active: true
      //       }
      //     ]
      //   }
      // },
      {
        path: '/site/form-config/:website_id',
        name: 'FormMembers',
        component: FormMembers,
        meta: {
          requiresAuth: true,
          breadcrumb: [
            {
              title: 'website',
              link: 'Site',
              active: false,
              params: 'website_id'
            },
            {
              title: 'form-members',
              active: true
            }
          ]
        }
      },
      {
        path: '/analytics/:id/:type?',
        name: 'Analytics',
        component: Analytics,
        meta: {
          requiresAuth: true,
          breadcrumb: [
            {
              title: 'website',
              link: 'Site',
              active: false,
              params: 'id'
            },
            {
              title: 'gdpr-analytics-type',
              active: true
            }
          ]
        }
      },
      {
        path: '/items/:layout_id?/:id?/:type_item?',
        name: 'Items',
        component: Items,
        meta: {
          requiresAuth: true,
          breadcrumb: [
            {
              title: 'website',
              link: 'Site',
              active: false,
              params: 'id'
            },
            {
              title: 'items-all-edit',
              active: true
            }
          ]
        }
      },
      {
        path: '/site/cheetah-turbo/page/:id',
        name: 'CheetahTurboPage',
        component: CheetahTurboPage,
        meta: {
          requiresAuth: true,
          breadcrumb: [
            {
              title: 'website',
              link: 'SitePages',
              active: false,
              params: 'id'
            }
          ]
        }
      },
      {
        path: '/site/cheetah-turbo/page/edit/:id/:page_id',
        name: 'CheetahTurboPageEdit',
        component: CheetahTurboPage,
        meta: {
          requiresAuth: true,
          breadcrumb: [
            {
              title: 'website',
              link: 'SitePages',
              active: false,
              params: 'id'
            }
          ]
        }
      },
      {
        path: '/site/domain/:id',
        name: 'Domain',
        component: Domain,
        meta: {
          breadcrumb: [
            {
              title: 'website',
              link: 'Site',
              active: false,
              params: 'id'
            },
            {
              title: 'new-domain',
              active: true
            }
          ]
        }
      },
      {
        path: '/site/others/:id',
        // name: 'SiteSettings',
        // component: SiteSettings,
        name: 'Others',
        component: Others,
        meta: {
          requiresAuth: true,
          breadcrumb: [
            {
              title: 'website',
              link: 'Site',
              active: false,
              params: 'id'
            },
            {
              title: 'others',
              active: true
            }
          ]
        }
      },
      // {
      //   path: '/site/vote/:id',
      //   name: 'VoteSystem',
      //   component: VoteSystem,
      //   meta: {
      //     breadcrumb: [
      //       {
      //         title: 'website',
      //         link: 'Site',
      //         active: false,
      //         params: 'id'
      //       },
      //       {
      //         title: 'system vote',
      //         active: true
      //       }
      //     ]
      //   }
      // },
      // {
      //   path: '/site/vote/edit/:vote_id/:id',
      //   name: 'VoteSystemEdit',
      //   component: VoteEdit,
      //   meta: {
      //     breadcrumb: [
      //       {
      //         title: 'website',
      //         link: 'SitePages',
      //         active: false,
      //         params: 'id'
      //       },
      //       {
      //         title: 'system vote',
      //         active: true
      //       }
      //     ]
      //   }
      // }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/routes.js